// extracted by mini-css-extract-plugin
export default {"root":"ConfirmEmail_root__znpZe","container":"ConfirmEmail_container__iFGt0","footer":"ConfirmEmail_footer__5P03C"};